import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { initialTeamsState } from './teams.state'

const teamsSlice = createSlice({
  name: 'teams',
  initialState: initialTeamsState,
  reducers: {
    setModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload
    },
  },
})

export const { setModalOpen } = teamsSlice.actions
export default teamsSlice.reducer
